import React, { FC, useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';

import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import Button from '../../../../../../components/Button';
import { toHandicap } from '../../../../../../contrib/Utils/toHandicap';
import { SummaryTable } from './Components/SummaryTable';
import { TabPanel } from './Components/TabPanel';
import { ITeamHoleScore } from '../../../../../common/Hooks/useLeaderboardsResults';
import {
  RoundScoreSummaryProvider,
  useRoundScoreSummaryDispatch,
  useRoundScoreSummaryState
} from '../../../../../../components/RoundScoreSummary/Context/RoundScoreSummary.context';

interface IProps {
  itemHandicap: number;
  penalties?: number;
  playerScores?: ITeamHoleScore;
  range: {
    start: number;
    length: number;
  };
  scoreType: ScoreType;
  hideHandicapsRow: boolean;
  hideIndexRow?: boolean;
}

const RoundScoreSummaryComponent: FC<IProps> = props => {
  const {
    hideHandicapsRow,
    hideIndexRow,
    itemHandicap,
    penalties,
    playerScores,
    range,
    scoreType
  } = props;

  const {
    actions: { processScores }
  } = useRoundScoreSummaryDispatch();

  const { totalGross, totalNet } = useRoundScoreSummaryState();

  useEffect(() => {
    if (playerScores) {
      processScores({ scores: playerScores.scores, scoreType, penalties });
    }
  }, [playerScores]);

  const [page, setPage] = useState(Number(range.start === 9));
  const handleChangeIndex = (index: number) => {
    setPage(index);
  };

  const togglePage = () => {
    setPage(page === 0 ? 1 : 0);
  };

  return (
    <div className="scorer-paper round-score-summary">
      <div className="content">
        <SwipeableViews
          index={page}
          dir={!page ? 'x' : 'x-reverse'}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={page} index={0} dir={'x'}>
            <SummaryTable
              hideHandicapsRow={true}
              hideParRow={true}
              partials={[{ name: 'OUT', from: 0, to: 8 }]}
              start={0}
              scoreType={scoreType}
              end={9}
            />
          </TabPanel>

          <TabPanel value={page} index={1} dir={'x'}>
            <SummaryTable
              hideHandicapsRow={true}
              hideParRow={true}
              partials={[{ name: 'IN', from: 9, to: 17 }]}
              start={9}
              scoreType={scoreType}
              end={18}
            />
          </TabPanel>
        </SwipeableViews>

        <div className="stats-row">
          {!hideHandicapsRow && (
            <>
              <div className="stat-title">EVENT HANDICAP:</div>

              <div className="stat-value">
                {playerScores ? toHandicap(playerScores.handicap) : 0}
              </div>
            </>
          )}

          {!hideIndexRow && (
            <>
              <div className="stat-title">INDEX:</div>
              <div className="stat-value">{itemHandicap}</div>
            </>
          )}
        </div>

        <div className="totals">
          {(scoreType === ScoreType.GROSS || scoreType === undefined) && (
            <div>
              <div className="total-title">GROSS</div>

              <div className="total-value">
                <div>{totalGross}</div>
              </div>
            </div>
          )}

          {(scoreType === ScoreType.NET || scoreType === undefined) && (
            <div>
              <div className="total-title">NET</div>

              <div className="total-value">
                <div>{totalNet}</div>
              </div>
            </div>
          )}

          {range.length > 9 && (
            <Button onClick={togglePage} color="primary">
              {page === 1 ? 'FRONT' : 'BACK'} 9
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const RoundScoreSummary: FC<IProps> = props => {
  return (
    <RoundScoreSummaryProvider>
      <RoundScoreSummaryComponent {...props} />
    </RoundScoreSummaryProvider>
  );
};

export default RoundScoreSummary;
